const pTry = (callback, ...args): any =>
  new Promise((resolve) => {
    resolve(callback(...args))
  })

const pLimit = (concurrency): any => {
  if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) {
    return Promise.reject(new TypeError('Expected `concurrency` to be a number from 1 and up'))
  }

  const queue = []
  let activeCount = 0

  const next = (): any => {
    activeCount -= 1

    if (queue.length > 0) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      queue.shift()()
    }
  }

  const run = (fn, resolve, ...args): any => {
    activeCount += 1

    const result = pTry(fn, ...args)

    resolve(result)

    result.then(next, next)
  }

  const enqueue = (fn, resolve, ...args): any => {
    if (activeCount < concurrency) {
      run(fn, resolve, ...args)
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
      queue.push(run.bind(null, fn, resolve, ...args))
    }
  }

  const generator = (fn, ...args): any => new Promise((resolve) => enqueue(fn, resolve, ...args))
  Object.defineProperties(generator, {
    activeCount: {
      get: () => activeCount,
    },
    pendingCount: {
      get: () => queue.length,
    },
  })

  return generator
}

export default pLimit
